import { FieldValues, UseFormRegister } from "react-hook-form";
import clsx, { ClassValue } from "clsx";
import { InputCommonProps } from "./input-types";

type ReturnValues<
  E extends Element,
  Register extends UseFormRegister<FieldValues>,
> = Pick<
  InputCommonProps<E, Register>,
  | "readOnly"
  | "name"
  | "defaultValue"
  | "value"
  | "disabled"
  | "onChange"
  | "onBlur"
> & {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  ref?: (instance: any) => void;
  "data-testid"?: string;
  id?: string;
};

export const getInputSettings = <
  E extends HTMLElement,
  Register extends UseFormRegister<FieldValues> = UseFormRegister<FieldValues>,
>(
  props: InputCommonProps<E, Register>,
) => {
  let settings: ReturnValues<E, Register> = {
    readOnly: props.readOnly,
    "data-testid": props.testId,
    id: props.id,
    name: props.name,
    defaultValue: props.defaultValue,
    value: props.value,
    disabled: props.disabled,
    onChange: props.onChange,
  };

  if ("register" in props && props.name) {
    settings = {
      ...settings,
      ...props.register(props.name),
    };
  }

  if (props.onBlur) {
    settings = {
      ...settings,
      onBlur: props.onBlur,
    };
  }

  return settings;
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDataset = (props: { [K: string]: any }) =>
  Object.keys(props).reduce((result, key) => {
    if (key.indexOf("data-") === 0) {
      return {
        ...result,
        // eslint-disable-next-line @typescript-eslint/no-explicit-any,@typescript-eslint/no-unsafe-assignment
        [key]: props[key],
      };
    }

    return result;
  }, {});

export const getInputCss = (
  error: string | boolean,
  ...classes: ClassValue[]
) => {
  return clsx(classes, error && "invalid");
};
